import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Card, ListGroup, ListGroupItem } from 'reactstrap';
import PropTypes from 'prop-types';
import { hideNewPaymentMethod } from '../../enums';

export const Navigation = ({
  tab,
  handleBackToMyAccount,
  isSubscriptionFromApps,
  history,
  client,
  hasInvoices,
  countryCode,
  hasPreMigrationSubscription,
  hasPlanSubscriptionWithFreepass,
  hasPlanSubscriptionWithAffiliates
}) => {
  return (
    <Card className="myAccount__card">
      <ListGroup flush className="nav">
        <ListGroupItem
          tag="a"
          action
          className="cursor"
          active={tab === 'general'}
          onClick={() => history.push(`/${client}/subscribe/subscriptions/general${history.location.search}`)}
        >
          <FormattedMessage id="MyAccount.menu.generalInformation" />
        </ListGroupItem>
        <ListGroupItem
          tag="a"
          className="cursor"
          action
          active={tab === 'myaccount'}
          onClick={() => history.push(`/${client}/subscribe/subscriptions/myaccount${history.location.search}`)}
        >
          <FormattedMessage id="MyAccount.menu.subscription" />
        </ListGroupItem>
        {!isSubscriptionFromApps && !hideNewPaymentMethod.includes(countryCode) && !hasPreMigrationSubscription && !hasPlanSubscriptionWithFreepass && !hasPlanSubscriptionWithAffiliates &&
          <ListGroupItem
            tag="a"
            className="cursor"
            action
            active={['payment-methods', 'new-payment-method'].includes(tab)}
            onClick={() => history.push(`/${client}/subscribe/subscriptions/payment-methods${history.location.search}`)}
          >
            <FormattedMessage style={{ display: 'none !important' }} id="MyAccount.menu.paymentMethod" />
          </ListGroupItem>}
        {/* TODO: handle this after buy something with affiliates method */}
        {
           hasInvoices && !hasPlanSubscriptionWithFreepass &&
            <ListGroupItem
              tag="a"
              action
              className="cursor"
              active={tab === 'invoices'}
              onClick={() => history.push(`/${client}/subscribe/subscriptions/invoices${history.location.search}`)}
            >
              <FormattedMessage id="MyAccount.menu.myAccount" />
            </ListGroupItem>
        }
      </ListGroup>
    </Card>
  );
};

Navigation.propTypes = {
  tab: PropTypes.string.isRequired,
  client: PropTypes.string.isRequired,
  history: PropTypes.object.isRequired,
  handleBackToMyAccount: PropTypes.func.isRequired,
  isSubscriptionFromApps: PropTypes.bool.isRequired,
  hasInvoices: PropTypes.bool.isRequired,
  countryCode: PropTypes.string.isRequired,
  hasPreMigrationSubscription: PropTypes.bool.isRequired,
  hasPlanSubscriptionWithFreepass: PropTypes.bool.isRequired,
  hasPlanSubscriptionWithAffiliates: PropTypes.bool.isRequired
};
